<mat-card-header class="system-message error">
  <div mat-card-avatar >
    <mat-icon [svgIcon]="icon" class="nsc-icon__svg"></mat-icon>  
  </div>
    <mat-card-title>
      @switch (headingLevel) {
        @case (1) { <h1>{{title}}</h1> }
        @case (2) { <h2>{{title}}</h2> }
        @case (3) { <h3>{{title}}</h3> }
        @case (4) { <h4>{{title}}</h4> }
        @case (6) { <h6>{{title}}</h6> }
        @default  {
          <h5>{{title}}</h5>
        }
      }
    </mat-card-title>
    <mat-card-subtitle>
      <ng-content></ng-content>
    </mat-card-subtitle>
  </mat-card-header>